import { render } from "./menu_landingCTA.vue?vue&type=template&id=710efb8c&scoped=true"
import script from "./menu_landingCTA.vue?vue&type=script&lang=js"
export * from "./menu_landingCTA.vue?vue&type=script&lang=js"

import "./menu_landingCTA.vue?vue&type=style&index=0&id=710efb8c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710efb8c"]])

export default __exports__